var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-geo-json',{attrs:{"geojson":_vm.outlineGeojson,"optionsStyle":{
    weight: 2,
    color: '#000000',
    opacity: 1,
    fillColor: 'rgba(0,0,0,0)',
    fillOpacity: 0.2
  }}})
}
var staticRenderFns = []

export { render, staticRenderFns }